export class ConstantModel {
  constantId: string;
  value: number;
  uom: string;
  lastModifiedBy: string;
  createdBy?: string;
  filterResponse?:any
}
